module.exports = __webpack_public_path__ + "static/img/pic_tgcs@2x.6b8d9239.png";